export default {
  user: state => {
    return state.user;
  },
  metadata: state => {
    return state.user.metadata;
  },
  selectedAgs: state => {
    return state.selectedAgs;
  },
  selectedUpdate: state => {
    return state.selectedUpdate;
  },
  selectedYearIndex: state => {
    return state.selectedYearIndex;
  },
  selectedYear: state => {
    if (state.selectedUpdate && state.selectedUpdate.year) {
      return state.selectedUpdate.year.split(",")[state.selectedYearIndex];
    }
    return null;
  },
  updates: state => {
    return state.updates;
  },
  ags: state => {
    return state.ags;
  },
  updatesFilteredByAgs(state) {
    return state.selectedAgs
      ? state.updates.filter(update => update.agsId == state.selectedAgs.agsId)
      : [];
  },
  pointLayerTypes(state) {
    return state.pointLayerTypes;
  },
  tileLayerTypes(state) {
    return state.tileLayerTypes;
  },
  heatMapLayerTypes(state) {
    return state.heatMapLayerTypes;
  },
  geoInputTypes(state) {
    return state.geoInputTypes;
  },
  geoInputIcons() {
    return {
      Hotel: {
        name: "fa-hotel",
        unicode: "\uf594"
      },
      "Ladestationen Bundesnetzagentur": {
        name: "fa-charging-station",
        unicode: "\uf5e7"
      },
      ONS: { name: "fa-plug", unicode: "\uf1e6" },
      "OSM Ladestationen": { name: "fa-charging-station", unicode: "\uf5e7" },
      Parkplaetze: { name: "fa-parking", unicode: "\uf540" },
      "Parkplaetze privat": { name: "fa-parking", unicode: "\uf540" },
      Veranstaltungsorte: { name: "fa-star", unicode: "\uf005" }
    };
  }
};
